<template>
  <div class="progress-wrapper">
    <div id="track" class="progress-track">
      <div id="fill" class="progress-fill" aria-hidden="true"></div>

      <!-- 0% dot은 숨김 처리 -->
      <div class="dot first" style="left: 0%" data-value="0" @click="onClickDot"></div>
      <div class="dot" style="left: 10%" data-value="10" @click="onClickDot"></div>
      <div class="dot" style="left: 20%" data-value="20" @click="onClickDot"></div>
      <div class="dot" style="left: 30%" data-value="30" @click="onClickDot"></div>
      <div class="dot" style="left: 40%" data-value="40" @click="onClickDot"></div>
      <div class="dot" style="left: 50%" data-value="50" @click="onClickDot"></div>
      <div class="dot" style="left: 60%" data-value="60" @click="onClickDot"></div>
      <div class="dot" style="left: 70%" data-value="70" @click="onClickDot"></div>
      <div class="dot" style="left: 80%" data-value="80" @click="onClickDot"></div>
      <div class="dot" style="left: 90%" data-value="90" @click="onClickDot"></div>
      <div class="dot hidden" style="left: 100%" data-value="100" @click="onClickDot"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
      required: false
    },
    maxvalue: {
      type: Number,
      default: 80,
      required: false
    }
  },
  created() {
    this.percentvalue = this.value;
  },
  data() {
    return {
      percentvalue: 0,
      fill: null,
      root: document.documentElement
    };
  },
  emits: ['click-dot', 'click-overvalue'],
  mounted() {
    this.fill = document.getElementById('fill');
    this.setProgress(this.percentvalue);
  },
  methods: {
    setProgress(v) {
      const n = Math.max(0, Math.min(100, +v));
      this.root.style.setProperty('--progress', n);
      this.fill.setAttribute('aria-valuenow', n);
      this.fill.setAttribute('aria-valuetext', n + '%');
    },
    onClickDot(event) {
      if (parseInt(event.target.dataset.value) > this.maxvalue) {
        this.$emit('click-overvalue');
        return;
      }
      this.percentvalue = parseInt(event.target.dataset.value);

      this.setProgress(this.percentvalue);
      this.$emit('click-dot', this.percentvalue);
    }
  },
  watch: {
    value(val) {
      this.percentvalue = val;
      this.setProgress(val);
    }
  }
};
</script>
<style scoped src="@/assets/css/building/buildingprogressbar.css"></style>
